import React from 'react';
import LandingPageLayout from 'components/LandingPageLayout';
import VideoReview from 'components/LandingPageVideoReview';
import StaysLocation from 'components/LandingPageStaysLocation';
import SoulroomersGallery from 'components/LandingPageSoulroomersGallery';
import ReservationForm from 'components/LandingPageReservationForm';
import AboutUsSlider from 'components/LandingPageAboutUsSlider';
import { TitleSectionBtn } from 'components/LandingPageTitleSection/TitleSectionBtn';
import Head from 'next/head';
import WhyChooseSoulrooms from 'components/landingPageWhyChooseSoulrooms';
const FindRoomMatesInToronto = () => {
  return (
    <>
      <Head>
        <meta charset="utf-8" />
        <meta http-equiv="X-UA-Compatible" content="IE=edge" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <title>Roommates made simple</title>
        <meta name="description" content="Get AI to help you rent a room and find a roommate. No scams. No bullshit." />
        <meta name="author" content="SoulRooms" />
        <meta property="og:url" content="https://soulrooms.com/find-roommates-in-toronto" />
        <meta property="og:site_name" content="SoulRooms" />
        <meta property="og:title" content="Roommates made simple." />
        <meta
          property="og:description"
          content="Get AI to help you rent a room and find a roommate. No scams. No bullshit."
        />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://img1.wsimg.com/isteam/videos/naBxa52" />
        <meta property="og:locale" content="en_US" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="@soulroomsTO" />
        <meta name="twitter:title" content="SoulRooms" />
        <meta
          name="twitter:description"
          content="Get AI to help you rent a room and find a roommate. No scams. No bullshit."
        />
        <meta name="twitter:image" content="https://img1.wsimg.com/isteam/videos/naBxa52" />
        <meta name="twitter:image:alt" content="SoulRooms" />
        <meta name="theme-color" content="#FCBD00" />

        <link rel="canonical" href="https://www.soulrooms.com/find-roommates-in-toronto" />
      </Head>
      <LandingPageLayout>
        <StaysLocation
          img={'/static/images/landingPages/find-roomates.png'}
          title={"ROOMMATES WILL LEAVE YOU, SOULROOMS WON'T."}
          description={
            <p className="  responsiveText pt-xl-4  pe-xl-1  " style={{ fontFamily: 'Josefin Sans', color: '#5E5E5E' }}>
              Who you live with is as important as the house you stay in. But unfortunately, people, unlike SoulRooms,
              are always on the move. Save yourself the hassle of finding a roommate all over again and choose from
              hundreds of rooms straight from the landlords.
            </p>
          }
          btnTitle={'Find your SoulRoom'}
          href="#JotFormIFrame-91797058303261"
        />
        {/* VIDEO REVIEW SECTION  */}
        <VideoReview
          spacing={true}
          details="You can spend the next minute or so to know what makes SoulRooms the right choice for hundreds of young professionals across the city or scroll down to know more."
          title={'BE A PART OF THE COOLEST COMMUNITY IN TORONTO'}
          bgColor={'#171717'}
          bgClr="#171717"
        />

        <WhyChooseSoulrooms
          title="WHY CHOSE SOULROOMS?"
          card1hd="Great Roommates"
          card1txt="Our personality matching algorithm works like a charm. We also have a SoulRooms for women only ensuring your comfort takes precedence over everything else. "
          card2hd="No Hassle"
          card2txt="No more posting at Facebook groups, Kijiji/craigslist and talking to strangers to find your roommate. You never have to take the financial burden of the whole place at SoulRooms."
          card1Img="/static/images/landingPages/find-roommates-in-toronto/roommates.png"
          card2Img="/static/images/landingPages/find-roommates-in-toronto/hassle.png"
        />

        {/* Add Title Section Button From Component */}
        <TitleSectionBtn spacing={true} btnTxt="Find your SoulRoom" href="#JotFormIFrame-91797058303261" bg="white" />
        {/* <SoulroomersGallery /> */}
        <SoulroomersGallery />

        {/* RESERVATION FORM  */}
        <ReservationForm heading="FILL IN YOUR REQUIREMENTS & SEE AVAILABLE OPTIONS">
          <iframe
            id="JotFormIFrame-91797058303261"
            title="Find a SoulRoom"
            onLoad={() => {
              window.parent.scrollTo(0, 0);
            }}
            allowTransparency="true"
            allowFullScreen="true"
            allow="geolocation; microphone; camera"
            src="https://form.jotform.com/91797058303261"
            frameBorder="0"
            style={{ minWidth: '100%', height: '640px', border: 'none' }}
            scrolling="no"></iframe>
        </ReservationForm>

        {/* ABOUT US SLIDER  */}
        <AboutUsSlider heading="As featured in:" />
      </LandingPageLayout>
    </>
  );
};

export default FindRoomMatesInToronto;
